// extracted by mini-css-extract-plugin
export default {"void":"styles_void__s0gR3","void_text":"styles_void_text__n-3FD","add_board_btn":"styles_add_board_btn__zTH8x"};